module.exports = __webpack_public_path__ + "img/sepidfinal.5d0062c4.gif";